export default "__VITE_ASSET__BzzOBwcz__"